<script lang="ts">
  export let html: { value: string };
</script>

{#if !!html?.value}
  {@html html.value}
{/if}
